import { atom } from 'nanostores';

export const $cheatSheet = atom(false);
